import React, { useState, useMemo, useCallback } from 'react'
import InputNumberDiwa from '../Generic/InputNumberDiwa'
import { channelTableFixedImport } from '../../Constants/TableConfiguration'
import {
  setChannelPropertyToSave,
  setCommissionsToSave,
  setMultishippingToSave,
} from '../../Slices/Settings/ChannelSlice'
import { retrieveRangeThresholds } from '../../Helpers/ChannelSettingsHelper'
import { defaultSectorId, defaultSupergroupId } from '../../Constants/Configuration'
import { useAppDispatch, useAppSelector } from '../../hooks'

function ChannelInput(props) {
  const dispatch = useAppDispatch()
  const channelList = useAppSelector(state => state.present.channel.channelList)
  // dopo call del 26/04/2023 con dev4side registrata commento questa proprietà perché non usata
  //const isTansportField = props.field === channelTableTransport
  const [value, setValue] = useState(0)
  const [inputActive, setInputActive] = useState(false)

  const currentChannel = useMemo(() => {
    return channelList.find(x => x.name === props.channelName)
  }, [channelList, props.channelName])

  const currentRangesThreshold = useMemo(() => {
    return retrieveRangeThresholds(currentChannel?.commissions || [])
  }, [currentChannel?.commissions])

  const currentValue = useMemo(() => {
    if (props.field) {
      return currentChannel[props.field]
    } else {
      return props.isThreshold ? props.threshold : props.value
    }
  }, [props, currentChannel])

  const storeChannelPropertyValue = useCallback(() => {
    if (props.field) {
      dispatch(
        setChannelPropertyToSave({
          name: props.channelName,
          field: props.field,
          value: value === 0 || !value ? null : value,
          date: new Date().toISOString(),
        }),
      )
    } else if (props.iso) {
      const multiShipping = {
        iso: props.iso,
        amount: value,
      }
      if (value !== props.value)
        dispatch(
          setMultishippingToSave({
            name: props.channelName,
            multiShipping: multiShipping,
            date: new Date().toISOString(),
          }),
        )
    } else {
      const valueRounded = value ? Math.round(value) : value
      if (props.isThreshold && currentRangesThreshold.find(x => x.threshold === valueRounded)) {
        return
      }

      const commission = {
        value: props.isThreshold ? props.value ?? null : valueRounded ?? null,
        threshold: props.isThreshold ? valueRounded ?? null : props.threshold ?? null,
        sectorId: props.sectorId ?? defaultSectorId,
        supergroupId: props.supergroupId ?? defaultSupergroupId,
      }

      dispatch(
        setCommissionsToSave({
          name: props.channelName,
          oldThreshold: props.threshold,
          commission: commission,
          date: new Date().toISOString(),
        }),
      )
    }

    setInputActive(false)
  }, [
    currentRangesThreshold,
    dispatch,
    props.channelName,
    props.field,
    props.isThreshold,
    props.sectorId,
    props.supergroupId,
    props.threshold,
    props.value,
    props.iso,
    value,
  ])

  const onInputPress = useCallback(
    event => {
      if (event.key === 'Escape') {
        storeChannelPropertyValue()
        setInputActive(false)
      }
    },
    [storeChannelPropertyValue],
  )

  return (
    <div className={props.className}>
      <InputNumberDiwa
        className={
          !inputActive ? 'count-box ' + (currentValue ? ' setted' : ' empty-content') : 'num-input discount-input'
        }
        min={0}
        max={props.max}
        controls={false}
        value={inputActive ? value : currentValue}
        onFocus={() => {
          setInputActive(true)
          setValue(currentValue)
        }}
        onChange={inputActive ? setValue : undefined}
        onValueConfirm={inputActive ? storeChannelPropertyValue : undefined}
        onKeyDown={inputActive ? onInputPress : undefined}
        addonAfter={
          props.iso
            ? ''
            : props.field
            ? currentValue && props.field === channelTableFixedImport
              ? '€ '
              : ''
            : (currentValue && !props.sectorId && !props.supergroupId && !props.isThreshold) || props.isPercentageHeader
            ? ' %'
            : ''
        }
      />
    </div>
  )
}

export default ChannelInput
